const updateItems = [
  { date: '07-31', title: '苍穹之刃 第28集已更新', type: '更新' },
  { date: '07-31', title: '新增纪录片专区：极境生存全系列上线', type: '上线' },
  { date: '07-30', title: '暗夜追光者 第15集火热更新中', type: '更新' },
  { date: '07-30', title: '经典港片4K修复计划第二期：五部武侠经典回归', type: '专题' },
  { date: '07-29', title: '暑期档专题上线：十大必看新片盘点', type: '专题' },
  { date: '07-29', title: '浮生若梦记 第32集准时更新', type: '更新' },
  { date: '07-28', title: '时空缉凶大结局超前点映已开放', type: '重磅' },
  { date: '07-28', title: '移动端播放器全面升级，加载速度提升40%', type: '公告' },
  { date: '07-27', title: '本周新增海外高分悬疑片12部', type: '上线' },
];

const typeStyles: Record<string, string> = {
  '更新': 'bg-primary-100 text-primary-700',
  '上线': 'bg-accent-100 text-accent-700',
  '专题': 'bg-secondary-100 text-secondary-700',
  '重磅': 'bg-accent-200 text-accent-800',
  '公告': 'bg-background-200 text-foreground-600',
};

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">蓝莓影院每日最新更新与平台动态，不错过任何精彩</p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[33px] top-0 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full whitespace-nowrap ${typeStyles[item.type] || 'bg-background-200 text-foreground-600'}`}>
                      {item.type}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base text-foreground-800 font-medium">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}